import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { BeatLoader } from 'react-spinners';

// set up amplify config
import { Amplify } from 'aws-amplify';
import { signUp, confirmSignUp, resendSignUpCode } from 'aws-amplify/auth';
import awsconfig from '../../aws-exports';

// Notification
import Notification from '../Notification';

import '../../../src/styles/login.css';

import { addUser } from '../../redux/actions/addUser';

Amplify.configure(awsconfig);

const SignUp = ({ onClose, setSuccessMsg }) => {

    const [email, setEmail] =  useState('');
    const [password, setPassword] = useState('');
    const [confirmationCode, setConfirmationCode] = useState('');
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [loadingSignup, setLoadingSignup] = useState(false);
    const [loadingConfirmSignup, setLoadingConfirmSignup] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const dispatch = useDispatch();

    const isSmallScreen = window.innerWidth < 600;
  
    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    }

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    }


  async function resendConfirmationCode(username) {
    try {
        const response = await resendSignUpCode({ username: username });
        console.log(`responseresponse = ${response}`);
        setIsConfirmed(true);       
    } catch (err) {
        console.log(err.message);
        if (err.message === 'User is already confirmed.') {
          
        let errorMsg = `User is already confirmed. You can sign in with this user.`;
        setErrorMsg(errorMsg);
        onClose();
        }
        else {
          setErrorMsg(err.message);
        }       
    }
}

  const handleSignUp = async (e) => {
      e.preventDefault();        
      try {
        setLoadingSignup(true); // start rendering loading icon
        await signUp({
          username: email, // Use email as the username
          password,
          options: {
            userAttributes: {
            email
          },
          autoSignIn: true
        },
        });
      
        setIsConfirmed(true);
        setLoadingSignup(false);  // stop rendering loading icon      
      } catch (error) {
        console.error('Error signing up:', error);
        setIsConfirmed(false);
        setLoadingSignup(false);  // stop rendering loading icon

        if (error.message === 'An account with the given email already exists.') {
          setLoadingSignup(true);
          await resendConfirmationCode(email);
          setLoadingSignup(false);             
        }
        else if (error.UsernameExistsException) {
          console.log('UsernameExistsException:', error);
          setErrorMsg('An account with the given email already exists.');
        }
      
        else {
          setErrorMsg(error.message);
        }
        
      }
    };

      const handleConfirmSignUp = async () => {
        try {
          setLoadingConfirmSignup(true);     // start rendering loading icon     
          await confirmSignUp({ username: email, confirmationCode }); // Use email for confirmation
          setLoadingConfirmSignup(false);  // stop rendering loading icon

          // add user data into users table
          const userData = { email: email, signup_time: new Date() }
          dispatch(addUser(userData));
          let successText = "Your sign up was successful. Please login to continue.";
          setSuccessMsg(successText);
          onClose();
        } catch (error) {
          console.error('Error confirming sign up:', error);
          setLoadingConfirmSignup(false);  // stop rendering loading icon
          setErrorMsg(error.message);
        }
      };

  return (
    <>
       
       
        {!isConfirmed ? (
          <form onSubmit={handleSignUp}>
              <div>
                <input className='input-box-signup'              
                required
                type="email"
                placeholder="Email"
                value={email}
                onChange={handleEmailChange}
                />   

                <input className='input-box-signup'
                required
                type="password"
                placeholder="Password"
                minLength={8}
                value={password}
                onChange={handlePasswordChange}
                />
                
                <button size={ isSmallScreen ? 'sm' : 'md' } className='signup-submit-btn'>Sign up</button>

                { loadingSignup ?
                  <div style={{ marginTop: '0.0em', textAlign: 'center' }}>
                    <BeatLoader size={5} color="#36d7b7"/>
                  </div> :
                  <div style={{ marginTop: '0.0em', height: '1.5em' }}>
                  
                  </div> 
                }

              </div>
              </form>

              ) :

            <div>
                  <input className='input-box-signup-confirmation'
                    type="text"
                    placeholder="Enter confirmation Code"
                    value={confirmationCode}
                    onChange={(e) => setConfirmationCode(e.target.value)}
                  />
                <div className='input-box-signup-confirmation-text' >
                  A confirmation code has been sent to <span >{email}</span>
                </div>
                <button onClick={handleConfirmSignUp} className='signup-confirm-code-btn'>Confirm</button>

                { loadingConfirmSignup ?
                  <div style={{ marginTop: '0.0em', textAlign: 'center' }}>
                    <BeatLoader size={5} color="#36d7b7"/>
                  </div> :
                  <div style={{ marginTop: '0.0em', height: '1.5em' }}>
                  
                  </div> 
                }
                
            </div>
        }
        
        { errorMsg && <Notification message={errorMsg} type="error" /> }
        
     </>
  )
}

export default SignUp